// Main entry — the production View. (No Container: PageHeader is a pure
// View.) Sim wrappers live under ./sim and are never imported here, so a
// production import of PageHeader can't pull in fixtures.
export { PageHeader } from "./PageHeader";
export type { PageHeaderProps } from "./PageHeader";
